$(function() {
    function initAccordion(triger, activeFirst, activeClass) {
        $(`.${triger}`).on('click', function H() {
            let self = $(this);
            $(`.${triger}`).not(self).removeClass(`${activeClass}`).siblings()
                .slideUp(400);
            if(self.hasClass(`${activeClass}`)) {
                self.removeClass(`${activeClass}`).siblings().slideUp(400);
            } else {
                $(this).addClass(`${activeClass}`).siblings()
                    .slideDown(400);
            }
        });

        if (activeFirst) {
            $(`.${activeFirst}:first-of-type .${triger}`).addClass(`${activeClass}`)
                .siblings()
                .slideDown(400);
        }
    }

    initAccordion('js-trigger-accordion', 'process__item', 'open');
});